<template>
  <div class="footer-box-mobile-container">
    <div class="basic-info-wrapper">
      <div class="info-line">地址：{{websiteInfo.address}}</div>
      <div class="info-line">电话：
        <a :href="`tel:${websiteInfo.telephone}`">{{websiteInfo.telephone}}</a>
      </div>
      <div class="info-line">邮箱：{{websiteInfo.email}}</div>
    </div>
    <div class="right-wrapper">
      <div class="info-line">{{websiteInfo.rightStatement}}</div>
    </div>
    <div class="icp-wrapper">
      <div class="info-line"><img class="icon" src="../../assets/gwab.png" />
        <a href="http://www.beian.miit.gov.cn" target="_blank">{{websiteInfo.icp}}</a>
      </div>
    </div>
    <div class="qrcode-wrapper">
      <img class="qrcode" :src="websiteInfo.wxPublicQrcodeUrl" />
      <div class="text">扫描二维码 关注官方微信</div>
    </div>
  </div>
</template>

<script>
import { getWebsiteInfo } from '@/api/column'

export default {
  name: 'FooterBoxMobile',
  data () {
    return {
      websiteInfo: {
        address: '',
        telephone: '',
        email: '',
        wxPublicQrcodeUrl: '',
        icp: ''
      }
    }
  },
  created () {
    getWebsiteInfo().then(res => {
      this.websiteInfo = res.data.websiteInfo
      this.$store.commit('SET_WEBSITE_INFO', this.websiteInfo)
    })
  }
}
</script>

<style lang="scss" scoped>
.footer-box-mobile-container {
  width: 100%;
  background-color: #404040;
  box-sizing: border-box;
  padding: 0.27rem 0.15rem 0.35rem;
  font-family: PingFangSC-Regular;
  font-size: 0.12rem;
  color: #999990;
  text-align: center;
  a {
    color: #999;
  }
  .info-line {
    line-height: 0.23rem;
  }
  .right-wrapper {
    margin-top: 0.15rem;
  }
  .icp-wrapper {
    margin-top: 0.19rem;
    .icon {
      margin-bottom: -0.08rem;
      margin-right: 0.1rem;
      width: 0.23rem;
      height: 0.26rem;
    }
    a {
      color: #9f9f9f;
      text-decoration: none;
    }
  }
  .qrcode-wrapper {
    display: none;
    margin-top: 0.25rem;
    margin-bottom: 0.35rem;
    // display: flex;
    box-sizing: border-box;
    padding: 0 0.2rem;
    justify-content: space-around;
    align-items: center;
    .qrcode {
      width: 1.05rem;
      height: 1.05rem;
    }
    .text {
      line-height: 1.05rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FooterBox/Mobile.vue